import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgGreenplumDatbase = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-greenplum-datbase';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M11.34 3.281A8.68 8.68 0 0 0 5.819 5.82c-1.344 1.343-2.192 3.027-2.485 4.94-.096.63-.096 1.85 0 2.48.398 2.594 1.87 4.839 4.07 6.205 1.518.943 3.456 1.42 5.206 1.282 2.156-.17 4.069-1.044 5.571-2.546s2.376-3.415 2.546-5.571c.214-2.714-.976-5.533-3.073-7.281-1.795-1.495-4.014-2.215-6.314-2.048m1.892 1.575a7.25 7.25 0 0 1 3.883 2.029c1.088 1.088 1.776 2.428 2.052 3.995.032.183.052.62.052 1.12s-.02.937-.052 1.12c-.275 1.564-.96 2.9-2.047 3.992-1.037 1.042-2.281 1.708-3.76 2.013-.404.084-.569.095-1.36.095s-.956-.011-1.36-.095c-1.461-.301-2.72-.97-3.731-1.981-1.122-1.122-1.79-2.418-2.075-4.024-.071-.4-.071-1.84 0-2.24a9 9 0 0 1 .384-1.441 7.39 7.39 0 0 1 4.221-4.221c.522-.201 1.029-.32 1.861-.435.266-.037 1.615.014 1.932.073M11.24 6.347c-1.366.219-2.389.71-3.25 1.559a5.3 5.3 0 0 0-1.403 2.274c-.194.599-.235.854-.256 1.58-.017.599-.008.768.065 1.171.223 1.237.775 2.324 1.616 3.183.327.334.507.451.845.548.709.203 1.457-.141 1.963-.902.229-.344.361-.636.6-1.32.754-2.167 1.903-3.19 4.309-3.835.512-.138.755-.272.924-.511s.22-.39.224-.658c.006-.458-.211-.878-.706-1.366a6.04 6.04 0 0 0-3.49-1.709c-.323-.039-1.229-.048-1.441-.014m1.157 1.495a4.4 4.4 0 0 1 1.506.437c.403.196.937.563 1.152.793l.115.122-.355.108c-1.192.362-2.231.937-2.98 1.649-.848.807-1.336 1.6-1.816 2.949-.255.718-.439 1.082-.625 1.239l-.126.106-.159-.153c-.27-.258-.625-.767-.83-1.189-1.056-2.175-.258-4.649 1.834-5.682.475-.235 1.141-.395 1.733-.416.08-.003.328.014.551.037"
    })
  }));
});
export default SvgGreenplumDatbase;